<!-- eslint-disable prettier/prettier -->
<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :fill="color" class="ki ki-arrow-left-parens" viewBox="0 0 24 24">
	<path d="M6,20c-2.4-1.8-4-4.7-4-8s1.6-6.2,4-8v1.3C4.2,7,3,9.3,3,12c0,2.7,1.2,5,3,6.7V20z M18,4v1.3c1.8,1.7,3,4,3,6.7 c0,2.7-1.2,5-3,6.7V20c2.4-1.8,4-4.7,4-8S20.4,5.8,18,4z M18,11.5l-10,0l4.5-5H11L6,12l5,5.5h1.5l-4.5-5l10,0V11.5z"/>
</svg>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		width?: number;
		height?: number;
		color?: string;
	}>(),
	{
		width: 24,
		height: 24,
		color: 'currentColor'
	}
);
</script>
